import getJobOfferBySlug from './getJobOfferBySlug'
import getJobOffers from './getJobOffers'

const jobOffers = {
  getJobOfferBySlug,
  getJobOffers
}

export default jobOffers
